// components/ChatBotLoader.tsx
import React from "react";

const ChatBotLoader: React.FC = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-10">
      <div className="w-10 h-10 border-4 border-t-transparent border-[#EF2BA0] rounded-full animate-spin"></div>
    </div>
  );
};

export default ChatBotLoader;
